// extracted by mini-css-extract-plugin
export default {"location":"location_location__dFtm9","icon":"location_icon__aya6h","text":"location_text__IMtvR"};